import { render, staticRenderFns } from "./ProductName.vue?vue&type=template&id=35e6f9ca&scoped=true&"
import script from "./ProductName.vue?vue&type=script&lang=js&"
export * from "./ProductName.vue?vue&type=script&lang=js&"
import style0 from "./ProductName.vue?vue&type=style&index=0&id=35e6f9ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e6f9ca",
  null
  
)

export default component.exports